import {
  Flexbox,
  Label,
  Modal,
  Sentiments,
  TextInput,
  Variants
} from "@sede-x/shell-ds-react-framework";
import {
  BlockLeft,
  Save
} from "@sede-x/shell-ds-react-framework/build/esm/components/Icon/components";
import { useState } from "react";

const MIN_NUMBER_OF_COPIES = 2;
const SplitTicketModal = ({
  onClose,
  onSuccess
}: {
  onClose: () => void;
  onSuccess: (copies: number) => void;
}) => {
  const [numberOfTickets, setNumberOfTickets] = useState(MIN_NUMBER_OF_COPIES);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setNumberOfTickets(value ? parseInt(value, 10) : 0);
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      title={"Copy Ticket"}
      bodyPadding={false}
      actions={[
        {
          label: "Cancel",
          action: onClose,
          props: {
            icon: <BlockLeft />,
            variant: Variants.Outlined,
            sentiment: Sentiments.Negative
          }
        },
        {
          label: "Copy",
          action: () => onSuccess(numberOfTickets - 1),
          props: {
            sentiment: Sentiments.Positive,
            icon: <Save />
          }
        }
      ]}>
      <Flexbox gap="1rem" margin=".5rem" alignItems="center">
        <Label>Number&nbsp;of&nbsp;copies:</Label>
        <TextInput
          min={MIN_NUMBER_OF_COPIES}
          type="number"
          onChange={handleOnChange}
          value={numberOfTickets}
        />
      </Flexbox>
    </Modal>
  );
};

export default SplitTicketModal;
